import React from "react";
import { useState, useEffect, useMemo, useRef } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Checkbox,
  DatePicker,
  Select,
  TimePicker,
  Row,
  Col,
  Table,
  Divider,
  Switch,
} from "antd";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import { Content } from "antd/lib/layout/layout";
import TitlePage from "@src/component/Desktop/titlePage";
import "./calendar.scss";
import { renderToString } from "react-dom/server";
import ApiCalendar from "../../api/backend/calendar";
import axios from "axios";
import {
  LeftOutlined,
  RightOutlined,
  ClockCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";

import {
  lang,
  KEY,
  COMMON_CONSTANT,
  ROLE_KEY,
  STYLE,
} from "@src/constants/common.const";
import {
  CloseCircleOutlined,
  SaveOutlined,
  DeleteOutlined,
  LoadingOutlined,
  SearchOutlined,
  PlusOutlined,
  FormOutlined,
  EditOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { checkRoleScreen } from "../../utils/roles";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import API from "../../api/backend/calendar";
import API_CL from "../../api/backend/managementCL";
import API_USER from "../../api/backend/managementRole";
import API_KBN from "../../api/backend/kbn";
import {
  MSG_CATCH,
  statusRes,
  showMessage,
  handleCatchError,
  showMessageChange,
  enterSearch,
  renderOption,
  INPUT_DATE,
} from "../../constants/utils";
import classPopup from "../../models/control/popup";
import { debounce, get, set } from "lodash";
import { isEmpty, isString, isObject } from "lodash";
import Loading from "../../component/Desktop/loading/loading";
import classText from "../../models/control/text";
import classDdl from "../../models/control/dropdownlist";
import allLocales from "@fullcalendar/core/locales-all";
import { useMediaQuery } from "react-responsive";
import { ColorPicker } from "@src/page/DynamicChartManagement/add";
import rolesConst from "@src/routers/roles/roles.const";
import TextArea from "antd/lib/input/TextArea";
import { HOLIDAY_TYPE } from "../../constants/common.const";

// Popup
const showMessageError = (msg) => {
  showMessage(KEY.ERROR, msg);
};

const showMessageWarning = (msg) => {
  showMessage(KEY.WARMING, msg);
};

export function dayCellClassNames({ date, view }) {
  const isWeekend = date.getDay() === 0 || date.getDay() === 6;
  const className = isWeekend ? "weekend-day" : "";
  return className ? className : null;
}

export default function DemoApp() {
  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const { isLeader } = useSelector((state) => state.auth);

  const isSmallScreen = useMediaQuery({ query: "(max-width: 1104px)" });
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: isSmallScreen ? 24 : 19 },
  };
  const location = useLocation();
  const { allowRoute, roleKey, displayName, userName, selectedFactory } =
    useSelector((state) => state.auth);
  const isMember = roleKey == ROLE_KEY.MEMBER;
  //Modal
  const [modal, setModal] = useState(new classPopup());
  const showModal = () => setModal({ ...modal, show: true });
  const hideModal = () => {
    setModal({ ...modal, show: false });
    setDataUpdate({});
    setDetails([]);
  };
  const [syncOutlook, setSynOutLook] = useState(false);

  // Loading
  const [showLoading, setShowLoading] = useState(false);
  const openLoadingSpinner = () => setShowLoading(true);
  const closeLoadingSpinner = () => setShowLoading(false);

  //State
  const [calendarMinDate, setCalendarMinDate] = useState(
    moment().startOf("month").subtract(7, "d").format("YYYY/MM/DD")
  );
  const [calendarMaxDate, setCalendarMaxDate] = useState(
    moment().endOf("month").add(7, "d").format("YYYY/MM/DD")
  );
  const [events, setEvents] = useState([]);

  const isMonthTypeView = useRef(false);
  const [dataUpdate, setDataUpdate] = useState({});
  const [form] = Form.useForm();
  const [initPage, setInitPage] = useState(true);
  const [details, setDetails] = useState([]);

  // MEMO
  const [publicMemoText, setPublicMemoText] = useState("");
  const [privateMemoText, setPrivateMemoText] = useState("");
  const [typeMemo, setTypeMemo] = useState("");

  const [isModalMemoVisible, setIsModalMemoVisible] = useState(false);
  const [tempText, setTempText] = useState("");
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentView, setCurrentView] = useState("timeGridWeek");

  // DAY OFF
  const [listDayOff, setListDayOff] = useState([]);

  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  //Input search
  const [type, setType] = useState(new classDdl());

  // Modal Custom time
  const [openCustomTime, setOpenCustomTime] = useState(false);

  // // Init
  const handleDatesSet = async ({ start, end, view }) => {
    if (view && view.type === "dayGridMonth") {
      isMonthTypeView.current = true;
    } else isMonthTypeView.current = false;

    const startTime = moment(start).format("YYYY/MM/DD");
    const endTime = moment(end).format("YYYY/MM/DD");
    setCalendarMinDate(startTime);
    setCalendarMaxDate(endTime);

    // Get currentMonth
    const midDate = new Date(start); // Lấy ngày bắt đầu
    midDate.setDate(
      midDate.getDate() + Math.floor((end - start) / (1000 * 60 * 60 * 24)) / 2
    ); // Tính ngày giữa

    const year = midDate.getFullYear(); // Lấy năm
    const month = String(midDate.getMonth() + 1).padStart(2, "0"); // Lấy tháng và đảm bảo có 2 chữ số
    setCurrentMonth(`${year}${month}`);
    await search_onClick(false, startTime, endTime);
  };

  const determineEventPosition = (event) => {
    if (event.allDayEvent) {
      return "full-day-event";
    }

    const startMoment = moment.unix(event.startTime);
    const endMoment = moment.unix(event.endTime);

    const startHour = startMoment.hour();
    const endHour = endMoment.hour();
    const countDay =
      endMoment.startOf("day").diff(startMoment.startOf("day"), "days") + 1;

    if (!startMoment.isSame(endMoment, "day")) {
      if (startHour >= 12 && endHour >= 12) {
        return `multi-day-event-start-pm-${countDay}`;
      } else if (startHour < 12 && endHour < 12) {
        return `multi-day-event-end-am-${countDay}`;
      } else if (startHour >= 12 && endHour < 12) {
        return `multi-day-event-start-pm-end-am-${countDay}`;
      }

      return "multi-day-event";
    } else {
      if (startHour < 12 && endHour < 12) {
        return "am";
      } else if (startHour >= 12 && endHour >= 12) {
        return "pm";
      } else {
        return "full-day-event";
      }
    }
  };

  const handleDateClick = (date) => {
    setDataUpdate({
      startTime: moment(date.date).startOf("day").unix(),
      endTime: moment(date.date).endOf("day").unix(),
      endDateS: moment(date.date).endOf("day").unix(),
      allDayEvent: true,
      repeat: null,
      remindBefore: null,
      fixedType: "1",
    });
    showModal();
  };

  const handleEventClick = (eventInfo) => {
    const eventOrig = events.find((x) => x.id == eventInfo.event.id);
    showModal();
    let finalEndTime = eventOrig.endTime;
    if (eventOrig.fixedType == 4) {
      finalEndTime = eventOrig.endTime;
    } else {
      finalEndTime = eventOrig.allDayEvent
        ? eventOrig.endTime - 1
        : eventOrig.endTime;
    }
    setDataUpdate({
      ...eventOrig,
      endTime: finalEndTime,
    });
    let details = [...eventOrig.details].splice(
      1,
      eventOrig.details.length - 1
    );
    details = details.map((i) => {
      return { ...i, endTime: i.allDayEvent ? i.endTime - 1 : i.endTime };
    });
    setDetails(details);
  };

  // Viết hàm validate các trường bắt buộc nhập
  const validateField = () => {
    let result = true;
    let error = {};
    if (!dataUpdate.taskName || !dataUpdate.taskName.trim()) {
      error.taskName = true;
      result = false;
      dataUpdate.taskName = null;
    }
    setDataUpdate({ ...dataUpdate, error: error });
    if (!result) {
      showMessageWarning(COMMON_CONSTANT.BOM_E031);
    }
    return result;
  };

  // Check Daily
  const isValidDailyRepeat = (start, end) => {
    if (!dataUpdate || dataUpdate.repeat != 1) {
      return;
    }
    if (!dataUpdate.allDayEvent) {
      start++;
    }
    const twentyFourHoursInMilliseconds = 24 * 60 * 60;

    if (end - start > twentyFourHoursInMilliseconds) {
      throw new Error(COMMON_CONSTANT.CONFIRM_OVERLAP_TIME_CALENDAR);
    }
  };

  const setEvent = async (eventInfo) => {
    const isUpdate = !!dataUpdate.id;
    if (!validateField()) {
      return;
    }
    try {
      let finalStartTime = +dataUpdate.startTime;
      let finalEndTime = +dataUpdate.endTime;
      // Sencond 59
      if (!dataUpdate.allDayEvent) {
        const date = moment.unix(finalEndTime);
        const newDate = date.seconds(1);
        const dateStart = moment.unix(finalStartTime).seconds(0);
        finalEndTime = newDate.unix();
        finalStartTime = dateStart.unix();
      }

      // Check daily
      isValidDailyRepeat(finalStartTime, finalEndTime);

      if (+dataUpdate.startTime == +dataUpdate.endTime) {
        finalEndTime = +dataUpdate.endTime;
      } else {
        if (+dataUpdate.startTime > +dataUpdate.endTime) {
          finalStartTime = +dataUpdate.endTime;
          finalEndTime = +dataUpdate.startTime;
        }
      }

      details.map((i) => {
        if (!i.allDayEvent) {
          const date = moment.unix(i.endTime);
          const newDate = date.seconds(1);
          const dateStart = moment.unix(i.startTime).seconds(0);
          i.endTime = newDate.unix();
          i.startTime = dateStart.unix();
        }
        if (i.allDayEvent) {
          i.startTime = moment.unix(i.startTime).clone().startOf("day").unix();
          i.endTime = moment.unix(i.endTime).clone().endOf("day").unix();
        }
        return i;
      });

      if (dataUpdate.allDayEvent) {
        finalStartTime = moment
          .unix(finalStartTime)
          .clone()
          .startOf("day")
          .unix();
        finalEndTime = moment.unix(finalEndTime).clone().endOf("day").unix();
      }

      const sourceDateTime = dataUpdate.repeat
        ? {
            startTime: +finalStartTime,
            endTime: +finalEndTime,
            allDayEvent: dataUpdate.allDayEvent,
          }
        : {
            startTime: +finalStartTime,
            endTime: +finalEndTime,
            allDayEvent: dataUpdate.allDayEvent,
            details: [
              {
                startTime: +finalStartTime,
                endTime: +finalEndTime,
                allDayEvent: dataUpdate.allDayEvent,
              },
            ].concat(details),
          };

      const body = {
        checklistName: dataUpdate.checklistName,
        checklistId: dataUpdate.checklistId,
        taskName: dataUpdate.taskName,
        username: isMember ? userName : dataUpdate.username,
        repeat: dataUpdate.repeat,
        remindBefore: dataUpdate.remindBefore,
        fixedType: dataUpdate.fixedType || 1,
        // startTimeConfig: moment(startTime).format("YYYY-MM-DD HH:mm:ss.SSS"),
        // endTimeConfig: moment(endTime).format("YYYY-MM-DD HH:mm:ss.SSS"),
        endDateS:
          dataUpdate.repeat && endRepeat
            ? dataUpdate.endDateS || dataUpdate.startTime
            : null,
        ...sourceDateTime,
      };

      setShowLoading(true);
      const res = await (!isUpdate
        ? API.setEvent(body)
        : API.updateEvent(body, dataUpdate.id));
      if (statusRes(res)) {
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003);
        search_onClick();
        hideModal();
      } else {
        showMessageError(MSG_CATCH());
      }
    } catch (err) {
      if (!axios.isAxiosError(err)) {
        showMessage(KEY.ERROR, err.message);
      } else if (err.response && err.response.status === 500) {
        showMessage(KEY.ERROR, COMMON_CONSTANT.CONFIRM_INVALID_TIME_CALENDAR);
      } else {
        handleCatchError(err);
      }
    } finally {
      setShowLoading(false);
    }
  };

  const deleteEvent = async (id) => {
    try {
      const res = await API.deleteEvent(id);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004);
      search_onClick();
      hideModal();
    } catch (e) {
      handleCatchError(e);
    }
  };

  // Search
  const search_onClick = async (init, startTime, endTime) => {
    startTime = startTime || calendarMinDate;
    endTime = endTime || calendarMaxDate;
    // Loading
    openLoadingSpinner();
    // Call
    try {
      const res = await API.getEvents(type.value || "", startTime, endTime);
      const resColor = await API.getCalendarConfig();
      const newToOldFormat = [];
      res.data.forEach((x) => {
        x.details.forEach((y) => {
          newToOldFormat.push({
            ...x,
            startTime: y.startTime,
            endTime: y.endTime,
            allDayEvent: y.allDayEvent,
            calendarDetailId: y.calendarDetailId,
          });
        });
      });

      const eventsData = newToOldFormat.map((x) => {
        const title =
          (x.taskName || x.checklistName) +
          (x.displayName ? `: ${x.displayName}` : "");
        const momentStartTime = moment.unix(x.startTime);
        const momentEndTime = moment.unix(+x.endTime);
        const thisType = resColor.data.find((y) => y.type == x.fixedType);
        return {
          ...x,
          title: title,
          start: momentStartTime.format(
            x.allDayEvent ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm:ss"
          ),
          end: momentEndTime.format(
            x.allDayEvent ? "YYYY-MM-DD" : "YYYY-MM-DD HH:mm:ss"
          ),
          backgroundColor: thisType.color || "#0080cb",
          borderColor: thisType.color || "#0080cb",
        };
      });

      if (isMonthTypeView.current) {
        const updatedEvents = eventsData.map((event) => ({
          ...event,
          className: determineEventPosition(event),
        }));
        setEvents(updatedEvents);
      } else {
        setEvents(eventsData);
      }
    } catch (error) {
      !init && showMessageError(MSG_CATCH());
    } finally {
      setInitPage(false);
      // Close loading
      closeLoadingSpinner();
      calendarRef.current
        .getApi()
        .scrollToTime(startTimeCalendarRef.current.format("HH:mm"));
    }
  };

  const fetchCheckList = async (value) => {
    try {
      const res = await API_CL.getData({
        params: { checklistName: value, status: 1 },
      });
      if (res && !isEmpty(res.data)) {
        return res.data.data.map((item) => ({
          label: item.checklistName,
          value: item.id,
        }));
      }
    } catch (e) {}
  };

  const fetchUser = async (value) => {
    try {
      const res = await API_USER.searchUserRole({
        user: value,
        siteOfficeMasterCode: selectedFactory,
        searchForCalendar: true,
      });
      if (res && !isEmpty(res.data)) {
        return res.data.data.map((item) => ({
          label: `${item.displayName} (${item.userName})`,
          value: item.userName,
        }));
      }
    } catch (e) {}
  };
  useEffect(() => {
    if (checkRoleScreen(location.pathname, allowRoute)) {
      search_onClick(null, null, null);
    }
  }, [allowRoute]);

  const disabledEndDate = (endDate) => {
    const startDate = moment.unix(dataUpdate.startTime);
    if (dataUpdate.repeat == 2) {
      return (
        startDate &&
        (endDate.valueOf() < startDate.valueOf() ||
          moment(endDate).diff(startDate, "week") !== 0)
      );
    }

    if (dataUpdate.repeat == 3) {
      return (
        startDate &&
        (endDate.valueOf() < startDate.valueOf() ||
          moment(endDate).diff(startDate, "month") !== 0)
      );
    }

    return startDate && endDate.valueOf() < startDate.valueOf();
  };

  const [formSearch] = Form.useForm();

  const [fixedType, setFixedType] = useState([]);
  const fetchFixedType = async () => {
    try {
      const res = await API_KBN.getCalendarFixedType();
      const resColor = await API.getCalendarConfig();
      if (res && !isEmpty(res.data)) {
        setFixedType(
          res.data.data.map((item) => {
            const thisType = resColor.data.find((x) => x.type == item.key);
            return {
              label: item.value,
              value: item.key,
              color: thisType.color,
              disabled: item.key != 1 && item.key != 2,
            };
          })
        );
      }
    } catch (e) {}
  };
  useEffect(() => {
    fetchFixedType();
  }, []);

  const onAddSetDate = () => {
    setDetails([
      ...details,
      {
        startTime: moment().startOf("day").unix(),
        endTime: moment().endOf("day").unix(),
        allDayEvent: true,
      },
    ]);
  };

  const onDeleteSetDate = (index) => {
    const newDetails = [...details];
    newDetails.splice(index, 1);
    setDetails(newDetails);
  };

  const onChangeDateDetails = (index, value, type) => {
    const newDetails = [...details];
    newDetails[index][type] = value;
    setDetails(newDetails);
  };

  const onChangeAllDayEventDetails = (index, value) => {
    const newDetails = [...details];
    newDetails[index].allDayEvent = value;
    setDetails(newDetails);
  };

  const canNotEdit =
    (isMember && dataUpdate.type == 2) ||
    dataUpdate.fixedType == 3 ||
    dataUpdate.fixedType == 4;

  const [endRepeat, setEndRepeat] = useState(true);
  useEffect(() => {
    if (dataUpdate.startTime > dataUpdate.endDateS) {
      setDataUpdate({
        ...dataUpdate,
        endDateS: moment.unix(dataUpdate.startTime).endOf("day").unix(),
      });
    }
  }, [dataUpdate.startTime]);

  const showModalEditRepeat = (dataEdit) => {
    Modal.confirm({
      title: lang.CONFIRM,
      icon: <QuestionCircleOutlined />,
      content: COMMON_CONSTANT.CONFIRM_DROP_REPEAT_TASK,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      centered: true,
      onOk() {
        handleEventClick(dataEdit);
      },
      onCancel() {
        dataEdit.revert();
      },
    });
  };
  // DROP EVENT
  const handleChangeEvent = (key) => async (info) => {
    // Info event
    const event = info.event;
    const start = event.start;
    const end = event.end || start;
    const newAllDayEvent = event.allDay;
    const oldAllDayEvent = info.oldEvent.allDay;
    const fromAllDayToTime = oldAllDayEvent && !newAllDayEvent;
    const fromTimeToAllDay = !oldAllDayEvent && newAllDayEvent;
    const fromTimeToTime = !oldAllDayEvent && !newAllDayEvent;
    const fromAllDayToAllDay = oldAllDayEvent && newAllDayEvent;

    const id = event.id;
    const eventOrig = events.find((x) => x.id == id);
    const dataCurrentEvent = info.event.extendedProps;
    try {
      // Check repeat
      if (dataCurrentEvent.repeat != null) {
        showModalEditRepeat(info);
        return;
      }

      // const firm
      Modal.confirm({
        title: lang.CONFIRM,
        icon: <QuestionCircleOutlined />,
        content: COMMON_CONSTANT.CONFIRM_DROP,
        okText: lang.OK,
        cancelText: lang.CANCEL,
        centered: true,
        onOk() {
          handleMove();
        },
        onCancel() {
          info.revert();
        },
      });

      async function handleMove() {
        try {
          let newStartTime = +moment(start).unix();
          let newEndTime = +moment(end).unix();

          if (fromAllDayToAllDay) {
            newEndTime = newEndTime - 1;
          }

          const newStartDate = moment.unix(newStartTime).toDate();
          const finalStartTime = newStartTime;

          const finalEndTime =
            (fromAllDayToTime ||
              fromTimeToAllDay ||
              (fromTimeToTime && !end)) &&
            key === "drop"
              ? newStartTime + 1
              : newEndTime;

          const { startDateTime, endDateTime, details, ...body } = eventOrig;
          const currentIdDetail = info.event.extendedProps.calendarDetailId;

          const detailUpdateIndex = (details || []).findIndex(
            (i) => i.calendarDetailId == currentIdDetail
          );
          if (detailUpdateIndex >= 0) {
            details[detailUpdateIndex].startTime = +finalStartTime;
            details[detailUpdateIndex].endTime = +finalEndTime;
            details[detailUpdateIndex].allDayEvent = newAllDayEvent;
          }
          const sourceDateTime = eventOrig.repeat
            ? {
                startTime: +finalStartTime,
                endTime: +finalEndTime,
                allDayEvent: newAllDayEvent,
              }
            : {
                startTime: +finalStartTime,
                endTime: +finalEndTime,
                allDayEvent: newAllDayEvent,
                details,
              };

          await API.updateEvent({ ...body, ...sourceDateTime }, id);
          showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003);
        } catch (error) {
          showMessage(KEY.ERROR, MSG_CATCH());
        } finally {
          search_onClick();
        }
      }
    } catch (error) {
      showMessage(KEY.ERROR, MSG_CATCH());
    } finally {
    }
  };

  // Get setting Time
  const getSettingTime = async () => {
    try {
      const res = await API.getTimeConfig();
      const data = res.data;
      if (data.startTimeConfig) {
        const startTimeFormat = moment(data.startTimeConfig, "HH:mm");
        setStartTime(startTimeFormat);
        // setStartTimeCalendar(startTimeFormat.startOf("hour"));
        startTimeCalendarRef.current = startTimeFormat;
        setRenderTrigger((prev) => !prev);
      }
      if (data.endTimeCofig) {
        const endTimeFormat = moment(data.endTimeCofig, "HH:mm");
        setEndTime(endTimeFormat);
        const roundedEndTime = endTimeFormat
          .clone()
          .add(1, "hour")
          .startOf("hour");
        const finalEnd =
          roundedEndTime.hour() < 24 && roundedEndTime.hour() > 0
            ? roundedEndTime
            : endTimeFormat;
        setEndTimeCalendar(finalEnd);
      }
    } catch (error) {}
  };
  useEffect(() => {
    getSettingTime();
  }, []);
  // Get Memo Text
  const getMemoText = async () => {
    try {
      const res = await API.getMemo(currentMonth);
      const data = res.data || [];
      const privateData = data.find((i) => i.type == 2);
      const publicData = data.find((i) => i.type == 1);
      if (privateData) {
        setPrivateMemoText(privateData.memo);
      } else {
        setPrivateMemoText("");
      }
      if (publicData) {
        setPublicMemoText(publicData.memo);
      } else {
        setPublicMemoText("");
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (currentView === "dayGridMonth" && currentMonth) {
      getMemoText();
    } else {
      setPrivateMemoText("");
      setPublicMemoText("");
    }
  }, [currentView, currentMonth]);

  // Hàm mở modal memo
  const showModalMemo = (type) => {
    const currentText = type == "1" ? publicMemoText : privateMemoText;
    setTypeMemo(type);
    setTempText(currentText);
    setIsModalMemoVisible(true);
  };

  const showConfirmMessage = (
    msg,
    callbackOK,
    callbackCancel,
    typeInfo = false
  ) => {
    let ok, cancel;
    const callBackDefault = () => {
      Modal.destroyAll();
    };

    // Callback OK exist
    if (callbackOK) {
      ok = () => {
        callbackOK();
        callBackDefault();
      };
    }
    // Callback Cancel exist
    if (callbackCancel) {
      cancel = () => {
        callbackCancel();
        callBackDefault();
      };
    }

    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: msg,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onCancel: cancel || callBackDefault,
      onOk: ok || callBackDefault,
    });
  };

  // SAVE MEMO
  const onSaveMemo = async () => {
    try {
      openLoadingSpinner();
      await API.addMemo(tempText, currentMonth, typeMemo);

      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () => {
        getMemoText();
      });
      setIsModalMemoVisible(false);
    } catch (error) {
      handleCatchError(error);
    } finally {
      closeLoadingSpinner();
    }
  };
  const handleSaveMemo = () => {
    showConfirmMessage(COMMON_CONSTANT.BOM_C008, onSaveMemo);

    // setText(tempText);
    // setIsModalMemoVisible(false);
  };

  // Hàm đóng modal
  const handleCancelModalMemo = () => {
    setIsModalMemoVisible(false);
  };
  const calendarRef = useRef(null);

  const [calendarTitle, setCalendarTitle] = useState("");
  const updateCalendarTitle = () => {
    const calendarApi = calendarRef.current.getApi();
    setCalendarTitle(calendarApi.view.title);
  };

  // Gọi hàm này khi nhấn các nút điều hướng hoặc chuyển đổi chế độ xem
  const handleTodayClick = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.today();
    updateCalendarTitle();
  };

  const handlePrevClick = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.prev();
    updateCalendarTitle();
  };

  const handleNextClick = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.next();
    updateCalendarTitle();
  };

  const handleViewChange = (viewType) => {
    calendarRef.current
      .getApi()
      .scrollToTime(startTimeCalendarRef.current.format("HH:mm"));
    const calendarApi = calendarRef.current.getApi();
    calendarApi.changeView(viewType);
    updateCalendarTitle();
    setCurrentView(viewType);
  };

  // Cập nhật tiêu đề khi component mount lần đầu tiên
  useEffect(() => {
    updateCalendarTitle();
  }, []);

  // List button mode calendar
  const listButtonModeCalendar = [
    {
      name: "月",
      mode: "dayGridMonth",
    },
    {
      name: "週",
      mode: "timeGridWeek",
    },
    {
      name: "日",
      mode: "timeGridDay",
    },
    {
      name: "ﾘｽﾄ",
      mode: "listMonth",
    },
  ];

  const [startTimeCalendar, setStartTimeCalendar] = useState(
    moment("00:00", "HH:mm")
  );
  const [endTimeCalendar, setEndTimeCalendar] = useState(
    moment("23:59", "HH:mm")
  );
  const startTimeCalendarRef = useRef(moment("00:00", "HH:mm"));
  const [renderTrigger, setRenderTrigger] = useState(false);
  // Modal Custom Time
  const closeModalCustomTime = () => {
    setOpenCustomTime(false);
  };

  const disabledMinutes = (selectedHour) => {
    if (!startTime) return [];
    const minutes = [];
    const minTime = startTime.hour(selectedHour).minute(0);
    for (let i = 0; i < 60; i += 5) {
      if (minTime.clone().add(i, "minutes").isAfter(startTime)) {
        minutes.push(i);
      }
    }
    return minutes;
  };

  const disabledEndMinutes = (selectedHour) => {
    if (!endTime) return [];
    const minutes = [];
    const maxTime = endTime.hour(selectedHour).minute(59);
    for (let i = 0; i < 60; i += 5) {
      if (maxTime.clone().subtract(i, "minutes").isBefore(endTime)) {
        minutes.push(i);
      }
    }
    return minutes;
  };

  // SAVE TIME CUSTOM
  const saveTimeCustom = async () => {
    // setIsScrolled(false);
    setEndTime(moment("23:59", "HH:mm"));
    if (!startTime) {
      return;
    }
    await API.addTimeConfig(startTime.format("HH:mm"), "23:59");
    startTimeCalendarRef.current = moment(startTime, "HH:mm");
    calendarRef.current.getApi().scrollToTime(startTime.format("HH:mm"));

    closeModalCustomTime();
  };

  // GET LIST HOLIDAY
  const getListDayoff = async () => {
    try {
      setShowLoading(true);
      const res = await ApiCalendar.getListDayOff();
      setListDayOff(
        res.data.map((item) => ({
          key: item.id,
          startDate: item.startDate,
          endDate: item.endDate,
          dayOffName: new classText(item.name),
          color: item.color,
          type: item.type,
        }))
      );
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };

  useEffect(() => {
    getListDayoff();
  }, []);

  useEffect(() => {
    setRenderTrigger(!renderTrigger);
  }, [listDayOff]);

  // SET COLOR
  const dayCellDidMount = (info) => {
    const cellDate = new Date(info.date);

    for (let range of listDayOff) {
      const startDate = new Date(range.startDate);
      const endDate = new Date(range.endDate);
      endDate.setHours(0, 0, 0, 0);
      startDate.setHours(0, 0, 0, 0);

      // YEALRY
      if (range.type == HOLIDAY_TYPE.YEARLY) {
        const yearlyStartDay = startDate.getDate();
        const yearlyStartMonth = startDate.getMonth();
        const yearlyEndDay = endDate.getDate();
        const yearlyEndMonth = endDate.getMonth();
        const yearlyCellDay = cellDate.getDate();
        const yearlyCellMonth = cellDate.getMonth();
        if (
          yearlyCellDay >= yearlyStartDay &&
          yearlyCellMonth >= yearlyStartMonth &&
          yearlyCellDay <= yearlyEndDay &&
          yearlyCellMonth <= yearlyEndMonth
        ) {
          if (info.el) {
            info.el.style.backgroundColor = range.color;
          }
        }
        continue;
      }
      //
      if (cellDate >= startDate && cellDate <= endDate) {
        if (info.el) {
          info.el.style.backgroundColor = range.color;
          continue;
        }
      }
    }
  };

  // Disabled repeat
  const disabledRepeat = () => {
    if (!dataUpdate) {
      return true;
    }
    if (!endRepeat) {
      return false;
    }
    const endRe = moment.unix(dataUpdate.endDateS).startOf("day");
    const start = moment.unix(dataUpdate.startTime).startOf("day");
    const end = moment.unix(dataUpdate.endTime).startOf("day");

    return (endRe <= start || endRe <= end) && dataUpdate.repeat;
  };

  useEffect(() => {
    const getStatus = async () => {
      try {
        const res = await API.getSyncStatusMail();
        const status = res.data;
        setSynOutLook(status == 1 ? true : false);
      } catch (error) {
        handleCatchError(error);
      }
    };
    getStatus();
  }, []);
  // CALL API sync outlook
  const handleSyncOutLook = async (checked) => {
    setShowLoading(true);
    const syncStatus = checked ? 1 : 0;
    setSynOutLook(checked);
    try {
      await API.updateSyncStatusMail(syncStatus);
    } catch (error) {
      setSynOutLook(!checked);
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };
  return (
    <>
      <div className="des-content calendar-content">
        <Modal
          centered
          width={isPC ? "25%" : "100%"}
          closeIcon={<></>}
          className=""
          title={lang.CUSTOM_TIME}
          visible={openCustomTime}
          getContainer={false}
          onCancel={closeModalCustomTime}
          footer={
            <Row>
              <Col span={4} style={{ textAlign: "left" }}></Col>
              <Col span={20} style={{ textAlign: "right" }}>
                <Button
                  key={1}
                  className="buttonPC button--info wAuto"
                  onClick={() => saveTimeCustom()}
                >
                  {lang.OK}
                </Button>
                <Button
                  onClick={closeModalCustomTime}
                  className="buttonPC --todo-- wAuto  button--outline"
                >
                  {lang.CANCEL}
                </Button>
              </Col>
            </Row>
          }
        >
          <Row align="middle">
            <Col span={24}>
              <Row>
                <Col span={24}>
                  <div className="mb5">{lang.START_TIME}</div>
                  <TimePicker
                    allowClear={false}
                    placeholder={lang.START_TIME}
                    value={startTime}
                    onChange={(time) => {
                      if (time) {
                        setStartTime(time);
                      }
                    }}
                    className={startTime ? "w100" : "w100 border-err"}
                    format="HH:mm"
                  />
                </Col>
                <Col
                  span={2}
                  className="center"
                  style={{ padding: "7px", marginTop: 25 }}
                >
                  {/* ～ */}
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal>
        <TitlePage name={lang.CALENDAR} />
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
          }}
        >
          {/* Group input */}
          <div>
            <Form
              name="searchRole"
              layout={"vertical"}
              form={formSearch}
              className="formStyle"
            >
              <Row align="stretch" gutter={[8, 8]}>
                <Col span={24} className="mr10">
                  <Row gutter={[8, 8]}>
                    <Col span="8">
                      <Form.Item
                        name="CATEGORY"
                        label="タイプ"
                        className="rowNotMargin"
                      >
                        <Select
                          placeholder="既定"
                          value={type.value}
                          className={type.error ? STYLE.BORDER_RED : ""}
                          onChange={(v) => {
                            setType({ ...type, value: v });
                          }}
                        >
                          {renderOption(
                            [
                              { key: null, value: "既定" },
                              { key: 1, value: COMMON_CONSTANT.ASSIGN_BY_ME },
                              {
                                key: 2,
                                value: COMMON_CONSTANT.ASSIGN_BY_CHIEF,
                              },
                            ],
                            false
                          )}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item className="rowNotMargin" label=" ">
                        <Button
                          className="buttonPC button--info wAuto mr8"
                          onClick={() => {
                            search_onClick(null, null, null);
                          }}
                        >
                          <SearchOutlined className="" />
                          {lang.SEARCH}
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </Content>
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
          }}
        >
          <Row
            className="custom-toolbar"
            justify="space-between"
            align="middle"
          >
            <Col>
              <div className="button-group-left">
                <button className="view-button" onClick={handlePrevClick}>
                  <LeftOutlined />
                </button>
                <button className="view-button" onClick={handleNextClick}>
                  <RightOutlined />
                </button>
                <button
                  style={{
                    marginLeft: 10,
                    borderRadius: "5px !important",
                  }}
                  className="view-button"
                  onClick={handleTodayClick}
                >
                  今日
                </button>
              </div>
            </Col>
            <Col>
              <h2 className="custom-calendar-title">{calendarTitle}</h2>{" "}
            </Col>
            <Col
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 10,
              }}
            >
              
              <div style={{
                display: "flex",
                alignItems: "center",

     }}>
              <span className="bold" style={{ marginRight: 10 }}>Outlook同期 : </span>
              <Switch
              className="custom-switch"
             style={{ transform: '1.2',marginRight:7}}
              
                checkedChildren="オン"
                unCheckedChildren="オフ"
                checked={syncOutlook}
                onChange={handleSyncOutLook}
              />
              </div>

              {isLeader && (
                // (currentView === "timeGridWeek" ||
                // currentView === "timeGridDay") &&
                <Button
                  className="buttonPC button--info wAuto mr8"
                  onClick={() => {
                    setOpenCustomTime(true);
                    setStartTime(startTimeCalendarRef.current);
                  }}
                >
                  <ClockCircleOutlined className="" />
                  {lang.CUSTOM_TIME}
                </Button>
              )}
              <div className="button-group-right">
                {listButtonModeCalendar.map((i) => (
                  <button
                    className={`view-button ${
                      i.mode === currentView ? "active" : ""
                    } `}
                    onClick={() => handleViewChange(i.mode)}
                  >
                    {i.name}
                  </button>
                ))}
              </div>
            </Col>
          </Row>

          {currentView === "dayGridMonth" && (
            <>
              <div className="wrap-memo">
                <div
                  onClick={() => {
                    if (!isLeader) {
                      return;
                    }
                    showModalMemo(1);
                  }}
                  className="memo-action"
                >
                  {isLeader && (
                    <EditOutlined
                      style={{
                        color: "#0080cb",
                      }}
                    />
                  )}
                  <strong
                    style={{
                      marginTop: 3,
                    }}
                  >
                    共通のメモ
                  </strong>
                </div>

                <p
                  style={{
                    wordWrap: "break-word",
                    maxWidth: "100%",
                    marginBottom: 0,
                  }}
                >
                  {publicMemoText}
                </p>
              </div>
              <div className="wrap-memo">
                <div onClick={() => showModalMemo(2)} className="memo-action">
                  <EditOutlined
                    style={{
                      color: "#0080cb",
                    }}
                  />{" "}
                  <strong
                    style={{
                      marginTop: 3,
                    }}
                  >
                    {" "}
                    個人のメモ
                  </strong>
                </div>
                <p
                  style={{
                    wordWrap: "break-word",
                    maxWidth: "100%",
                    marginBottom: 0,
                  }}
                >
                  {privateMemoText}
                </p>
              </div>
            </>
          )}
          <div>
            <FullCalendar
              key={renderTrigger}
              slotMinTime="00:00"
              slotMaxTime="23:59"
              scrollTime={startTimeCalendarRef.current.format("HH:mm")}
              height="600px"
              ref={calendarRef}
              editable
              plugins={[
                dayGridPlugin,
                interactionPlugin,
                timeGridPlugin,
                listPlugin,
              ]}
              initialView="timeGridWeek"
              initialDate={new Date()}
              datesSet={handleDatesSet}
              events={events
                .map((event) => ({
                  ...event,
                  editable:
                    (event.fixedType == 1 || event.fixedType == 2) &&
                    !(isMember && event.type == 2),
                }))
                .map((event) => {
                  let time = moment(event.end, "YYYY-MM-DD HH:mm:ss");
                  if (!event.allDayEvent) {
                    if (time.hours() === 0 && time.minutes() === 0) {
                      time.add(1, "seconds");
                    }
                    const newTime = moment(time).format("YYYY-MM-DD HH:mm:ss");
                    event.end = newTime;
                  }
                  return event;
                })}
              dateClick={handleDateClick}
              eventClick={handleEventClick}
              eventTimeFormat={eventTimeFormat}
              dayCellClassNames={dayCellClassNames}
              dayMaxEvents={3}
              eventMaxStack={3}
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
              }}
              locale="ja"
              locales={allLocales}
              buttonText={{
                today: "今日",
                month: "月",
                week: "週",
                day: "日",
                list: "ﾘｽﾄ",
              }}
              eventDrop={handleChangeEvent("drop")}
              eventResize={handleChangeEvent("resize")}
              dayCellDidMount={dayCellDidMount}
            />
          </div>
        </Content>
      </div>
      {!isEmpty(dataUpdate) && (
        <Modal
          centered
          width={isPC ? "55%" : "95%"}
          bodyStyle={{}}
          getContainer={false}
          closeIcon={<></>}
          className="modal-msg modal-padding"
          title={
            <div className="center">
              {dataUpdate.id
                ? dataUpdate.taskName
                  ? `${lang.TASK_NAME}：${dataUpdate.taskName}`
                  : `点検表：${dataUpdate.checklistName}`
                : `点検カレンダー作成`}
            </div>
          }
          visible={modal.show}
          footer={[
            ...(canNotEdit
              ? []
              : [
                  <Button
                    disabled={showLoading || disabledRepeat()}
                    key={1}
                    type="submit"
                    className="buttonPC button--info -- wAuto"
                    onClick={() => {
                      setEvent(null);
                    }}
                  >
                    <SaveOutlined />
                    {lang.OK}
                  </Button>,
                  <Button
                    key={2}
                    className="buttonPC button--error -- wAuto"
                    onClick={() => {
                      showMessageChange(() => deleteEvent(dataUpdate.id));
                    }}
                    hidden={!dataUpdate.id}
                  >
                    <DeleteOutlined />
                    {lang.DELETE}
                  </Button>,
                ]),
            ...[
              <Button
                key={3}
                className="buttonPC button--outline --todo-- wAuto"
                onClick={hideModal}
              >
                <CloseCircleOutlined />
                {lang.CLOSE}
              </Button>,
            ],
          ]}
        >
          <Form
            {...layout}
            layout={isSmallScreen ? "vertical" : "horizonal"}
            form={form}
          >
            <Form.Item
              label={
                <span>
                  {lang.TASK_NAME} <span style={{ color: "red" }}>*</span>
                </span>
              }
            >
              <Input
                className={
                  dataUpdate.error && dataUpdate.error.taskName
                    ? STYLE.BORDER_RED
                    : ""
                }
                value={dataUpdate.taskName}
                placeholder={lang.TASK_NAME}
                onChange={(e) => {
                  setDataUpdate({
                    ...dataUpdate,
                    taskName: e.target.value,
                    error: {
                      ...dataUpdate.error,
                      checklistId: false,
                      taskName: false,
                    },
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="点検表">
              <DebounceSelect
                className={
                  dataUpdate.error && dataUpdate.error.checklistId
                    ? STYLE.BORDER_RED
                    : ""
                }
                value={
                  dataUpdate.checklistId
                    ? {
                        value: dataUpdate.checklistId,
                        label: dataUpdate.checklistIdName,
                      }
                    : { value: null }
                }
                placeholder="点検表"
                fetchOptions={fetchCheckList}
                onChange={(newValue) => {
                  setDataUpdate({
                    ...dataUpdate,
                    checklistId: newValue ? newValue.value : null,
                    checklistIdName: newValue ? newValue.label : null,
                    error: {
                      ...dataUpdate.error,
                      checklistId: false,
                      taskName: false,
                    },
                  });
                }}
                allowClear={true}
              />
            </Form.Item>
            <Form.Item label={<span>{lang.CL_ITEM_NAME}</span>}>
              <Input
                value={dataUpdate.checklistName}
                placeholder={lang.CL_ITEM_NAME}
                onChange={(e) => {
                  setDataUpdate({
                    ...dataUpdate,
                    checklistName: e.target.value,
                    error: {
                      ...dataUpdate.error,
                      checklistName: false,
                    },
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="担当者">
              {!isMember && (
                <DebounceSelect
                  allowClear
                  className={
                    dataUpdate.error && dataUpdate.error.username
                      ? STYLE.BORDER_RED
                      : ""
                  }
                  value={
                    dataUpdate.username
                      ? {
                          value: dataUpdate.username,
                          label: `${dataUpdate.displayName} (${dataUpdate.username})`,
                        }
                      : { value: null }
                  }
                  placeholder="担当者"
                  fetchOptions={fetchUser}
                  onChange={(newValue) => {
                    if (!newValue) {
                      setDataUpdate({
                        ...dataUpdate,
                        username: null,
                        displayName: null,
                        error: { ...dataUpdate.error, username: false },
                      });
                      return;
                    }
                    setDataUpdate({
                      ...dataUpdate,
                      username: newValue.value,
                      displayName: newValue.label.substring(
                        0,
                        newValue.label.indexOf(" (")
                      ),
                      error: { ...dataUpdate.error, username: false },
                    });
                  }}
                />
              )}
              {isMember && (
                <Input defaultValue={`${displayName} (${userName})`} disabled />
              )}
            </Form.Item>
            <Form.Item label={"タイプ"}>
              <Row>
                <Col md={22} xs={20}>
                  <Select
                    value={
                      // fixedType.find((x) => x.value == dataUpdate.fixedType) ? fixedType.find((x) => x.value == dataUpdate.fixedType).label : null
                      dataUpdate.fixedType
                    }
                    onChange={(e) =>
                      setDataUpdate({ ...dataUpdate, fixedType: e })
                    }
                  >
                    {fixedType.map((item) => {
                      return (
                        <Select.Option
                          key={item.key}
                          value={item.value}
                          style={{}}
                          disabled={item.disabled}
                        >
                          <div
                            className="mr8"
                            style={{
                              width: 14,
                              height: 14,
                              borderRadius: "50%",
                              backgroundColor: item.color,
                              display: "inline-block",
                            }}
                          ></div>
                          {item.label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Col>
                <Col span={2}>
                  <ButtonModalType
                    callback={() => {
                      fetchFixedType();
                      search_onClick();
                    }}
                  />
                </Col>
              </Row>
            </Form.Item>
            <Form.Item label="繰返">
              <Select
                placeholder="頻度"
                disabled={details.length > 0}
                value={
                  repeat.find((x) => x.value == dataUpdate.repeat)
                    ? repeat.find((x) => x.value == dataUpdate.repeat).label
                    : ""
                }
                options={repeat}
                onChange={(e) => setDataUpdate({ ...dataUpdate, repeat: e })}
              />
            </Form.Item>
            {dataUpdate.repeat && (
              <Form.Item label="反復の終了日">
                <div>
                  <DatePicker
                    disabledDate={(currentDate) => {
                      return (
                        dataUpdate.startTime &&
                        dataUpdate.startTime * 1000 >= currentDate.valueOf()
                      );
                    }}
                    className="mr4"
                    allowClear={false}
                    format="YYYY/MM/DD"
                    value={moment.unix(dataUpdate.endDateS)}
                    onChange={(e) =>
                      setDataUpdate({
                        ...dataUpdate,
                        endDateS: moment(e).endOf("day").unix(),
                      })
                    }
                    disabled={!endRepeat}
                  />
                </div>
                <div>
                  <Checkbox
                    onChange={() => setEndRepeat(!endRepeat)}
                    checked={!endRepeat}
                  >
                    終了日なし
                  </Checkbox>
                </div>
              </Form.Item>
            )}
            <Form.Item label="日時">
              <div>
                <DatePicker
                  disabledDate={(currentDate) => {
                    return (
                      dataUpdate.endTime &&
                      dataUpdate.endTime * 1000 < currentDate.valueOf()
                    );
                  }}
                  className="mr4"
                  showTime={!dataUpdate.allDayEvent}
                  allowClear={false}
                  format={
                    dataUpdate.allDayEvent ? "YYYY/MM/DD" : "YYYY/MM/DD HH:mm"
                  }
                  value={moment.unix(dataUpdate.startTime)}
                  onChange={(e) =>
                    setDataUpdate({
                      ...dataUpdate,
                      startTime: dataUpdate.allDayEvent
                        ? moment(e).startOf("day").unix()
                        : moment(e).unix(),
                    })
                  }
                />
                ~
                <DatePicker
                  disabledDate={(currentDate) => {
                    return (
                      dataUpdate.startTime &&
                      dataUpdate.startTime * 1000 > currentDate.valueOf()
                    );
                  }}
                  className="ml4"
                  showTime={!dataUpdate.allDayEvent}
                  allowClear={false}
                  format={
                    dataUpdate.allDayEvent ? "YYYY/MM/DD" : "YYYY/MM/DD HH:mm"
                  }
                  value={moment.unix(dataUpdate.endTime)}
                  onChange={(e) =>
                    setDataUpdate({
                      ...dataUpdate,
                      endTime: dataUpdate.allDayEvent
                        ? moment(e).endOf("day").unix()
                        : moment(e).unix(),
                    })
                  }
                />
              </div>
              <div>
                <Checkbox
                  onChange={() =>
                    setDataUpdate({
                      ...dataUpdate,
                      allDayEvent: !dataUpdate.allDayEvent,
                    })
                  }
                  checked={dataUpdate.allDayEvent}
                >
                  終日イベント
                </Checkbox>
              </div>
              {details.map((x, index) => {
                return (
                  <>
                    <div key={index} className="mt4">
                      <DatePicker
                        disabledDate={(currentDate) => {
                          return (
                            x.endTime &&
                            x.endTime * 1000 < currentDate.valueOf()
                          );
                        }}
                        className="mr4"
                        showTime={!x.allDayEvent}
                        allowClear={false}
                        format={
                          x.allDayEvent ? "YYYY/MM/DD" : "YYYY/MM/DD HH:mm"
                        }
                        value={
                          x.startTime ? moment.unix(x.startTime) : moment.unix()
                        }
                        onChange={(e) =>
                          onChangeDateDetails(
                            index,
                            x.allDayEvent
                              ? moment(e).startOf("day").unix()
                              : moment(e).unix(),
                            "startTime"
                          )
                        }
                      />
                      ~
                      <DatePicker
                        disabledDate={(currentDate) => {
                          return (
                            x.startTime &&
                            x.startTime * 1000 > currentDate.valueOf()
                          );
                        }}
                        className="ml4"
                        showTime={!x.allDayEvent}
                        allowClear={false}
                        format={
                          x.allDayEvent ? "YYYY/MM/DD" : "YYYY/MM/DD HH:mm"
                        }
                        value={moment.unix(x.endTime)}
                        onChange={(e) =>
                          onChangeDateDetails(
                            index,
                            x.allDayEvent
                              ? moment(e).endOf("day").unix()
                              : moment(e).unix(),
                            "endTime"
                          )
                        }
                      />
                      <span
                        className="ml8"
                        style={{ color: "red", cursor: "pointer" }}
                        onClick={(index) => onDeleteSetDate(index)}
                      >
                        x
                      </span>
                    </div>
                    <div>
                      <Checkbox
                        onChange={(e) =>
                          onChangeAllDayEventDetails(index, e.target.checked)
                        }
                        checked={x.allDayEvent}
                      >
                        終日イベント
                      </Checkbox>
                    </div>
                  </>
                );
              })}
              <Button
                className="mt8"
                onClick={onAddSetDate}
                disabled={dataUpdate.repeat}
              >
                + 追加
              </Button>
            </Form.Item>
            <Form.Item label={lang.REMIND}>
              <Select
                value={
                  dataUpdate.remindBefore &&
                  remindBefore.find((x) => x.value == dataUpdate.remindBefore)
                    ? remindBefore.find(
                        (x) => x.value == dataUpdate.remindBefore
                      ).label
                    : null
                }
                options={remindBefore}
                onChange={(e) =>
                  setDataUpdate({ ...dataUpdate, remindBefore: e })
                }
              />
            </Form.Item>
          </Form>
          <Row>
            <Col span={20} offset={4}>
              {isMember && dataUpdate.type == 2 && (
                <p className="red mb0">
                  *他の人が作成したスケジュールを更新することはできません
                </p>
              )}
              {(dataUpdate.fixedType == 3 || dataUpdate.fixedType == 4) && (
                <p className="red mb0">*このイベントは編集できません</p>
              )}
            </Col>
          </Row>
        </Modal>
      )}
      <Loading show={showLoading}></Loading>
      <Modal
        title={typeMemo == 1 ? "共通のメモ編集 " : "個人のメモ編集 "}
        visible={isModalMemoVisible}
        getContainer={false}
        onOk={handleSaveMemo}
        onCancel={handleCancelModalMemo}
        okText={lang.OK}
        cancelText={lang.CANCEL}
        centered={true}
      >
        <div className="bold mb5">
          {typeMemo == 1 ? "共通のメモ " : "個人のメモ "}
        </div>
        <TextArea
          value={tempText}
          onChange={(e) => setTempText(e.target.value)}
          rows={4}
        />
      </Modal>
    </>
  );
}
const eventTimeFormat = {
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  meridiem: false,
};

const repeat = [
  { key: null, value: null, label: "繰り返し無し" },
  { key: 1, value: 1, label: "毎日" },
  { key: 2, value: 2, label: "毎週" },
  { key: 3, value: 3, label: "毎月" },
  { key: 6, value: 6, label: "3ヶ月" },
  { key: 7, value: 7, label: "6ヶ月" },
  { key: 4, value: 4, label: "年間" },
];

const remindBefore = [
  { key: null, value: null, label: "通知しない" },
  { key: 1, value: 5, label: "5分前に" },
  { key: 2, value: 15, label: "15分前に" },
  { key: 3, value: 30, label: "30分前に" },
  { key: 4, value: 60, label: "1時間前に" },
  { key: 5, value: 120, label: "2時間前に" },
  { key: 6, value: 720, label: "12時間前に" },
  { key: 7, value: 1440, label: "1日前までに" },
  { key: 8, value: 10080, label: "1週間前までに" },
];

export const CLASS_NAME_BY_FIXED_TYPE = {
  1: "event--confirmed",
  2: "event--plan",
  3: "event--repair",
  4: "event--calibration",
};

export function DebounceSelect({
  fetchOptions,
  debounceTimeout = 400,
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const fetchRef = useRef(0);
  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      setIsFirstTime(false);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(newOptions);
        setFetching(false);
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      showSearch
      labelInValue
      filterOption={false}
      onClick={() => isFirstTime && debounceFetcher("")}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <LoadingOutlined size="small" /> : null}
      {...props}
      options={options}
    />
  );
}

const getTimeTodayByEndTime = (startTime, endTime) => {
  const startDayTimeStamp = moment.unix(startTime).startOf("day").unix();
  const diffTime = endTime - moment.unix(endTime).startOf("day").unix();
  return moment.unix(startDayTimeStamp + diffTime);
};

export const ButtonModalType = ({ callback }) => {
  const { roles } = useSelector((state) => state.auth);
  const isAdmin = [
    rolesConst.OFFICE_ADMIN,
    rolesConst.HEAD_OFFICE_ADMIN,
  ].includes(roles);

  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });

  const [visible, setVisible] = useState(false);
  const [classification, setClassification] = useState([]);

  const getClassification = async () => {
    try {
      const res = await API_KBN.getCalendarFixedType();
      const resColor = await API.getCalendarConfig();
      if (res && !isEmpty(res.data)) {
        setClassification(
          res.data.data.map((item) => {
            const thisType = resColor.data.find((x) => x.type == item.key);
            return {
              label: item.value,
              value: item.key,
              color: thisType.color,
              disabled: item.key != 1 && item.key != 2,
            };
          })
        );
      }
    } catch (e) {}
  };

  const updateClassification = async () => {
    try {
      await API.setCalendarConfig(
        classification.map((item) => {
          return {
            type: item.value,
            color: item.color,
          };
        })
      );
      Modal.success({
        centered: true,
        title: <span style={{ fontWeight: "bold" }}>{lang.SUCCESS}</span>,
        content: COMMON_CONSTANT.BOM_C002,
        okText: lang.OK,
        onOk: callback,
      });
    } catch (e) {}
  };
  const setModalOn = () => {
    getClassification();
    setVisible(true);
  };

  const setModalOff = () => {
    setVisible(false);
  };

  const handleOK = async () => {
    await updateClassification();
    setVisible(false);
  };

  const column = [
    {
      title: "色",
      dataIndex: "color",
      key: "color",
      width: "10%",
      render: (color, record, index) => {
        return (
          <ColorPicker
            color={color}
            onChange={(color) => {
              const newClassification = [...classification];
              newClassification[index].color = color;
              setClassification(newClassification);
            }}
          />
        );
      },
    },
    {
      title: "タイプ",
      dataIndex: "label",
      key: "label",
      render: (text, record, index) => {
        return text;
      },
    },
  ];

  return (
    <>
      <Button
        disabled={!isAdmin}
        className="buttonPC button--info wAuto ml12"
        onClick={setModalOn}
        style={{ minWidth: "unset" }}
      >
        <FormOutlined />
      </Button>
      <Modal
        centered
        width={isPC ? "40%" : "100%"}
        closeIcon={<></>}
        className=""
        title={null}
        getContainer={false}
        visible={visible}
        onCancel={setModalOff}
        footer={
          <Row>
            <Col span={4} style={{ textAlign: "left" }}></Col>
            <Col span={20} style={{ textAlign: "right" }}>
              <Button
                key={1}
                className="buttonPC button--info wAuto"
                onClick={() => {
                  handleOK();
                }}
              >
                {lang.OK}
              </Button>
              <Button
                onClick={setModalOff}
                className="buttonPC --todo-- wAuto  button--outline"
              >
                {lang.CANCEL}
              </Button>
            </Col>
          </Row>
        }
      >
        <Table
          className="tableAddMachine"
          scroll={{ y: 300 }}
          rowKey="ItemOrder"
          dataSource={classification}
          columns={column}
          pagination={false}
          bordered
        />
      </Modal>
    </>
  );
};
